import Vue from 'vue'
import Echo from 'laravel-echo'

window.io = require('socket.io-client')

const echo = new Echo({
  broadcaster: 'socket.io',
  transports: ['websocket'],
  host: 'wss://ch-api.ikeamania.by',
})

Vue.prototype.$echo = echo

window.adminChannelName = 'admin'
